import { useMemo } from 'react';
import RemoveRedEye from '@mui/icons-material/RemoveRedEye';
import ImportExport from '@mui/icons-material/ImportExport';
import Payments from '@mui/icons-material/Payments';
import LibraryAddCheck from '@mui/icons-material/LibraryAddCheck';
import Delete from '@mui/icons-material/Delete';
import Schedule from '@mui/icons-material/Schedule';
import Edit from '@mui/icons-material/Edit';
import { SvgIconComponent } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { InvoiceStatus, InvoiceTableRowStatus } from '@lendica/utils';
import { ActionType, InvoiceTableRow } from '../sharedTypes';

export interface Action {
    title: string;
    onClick(): void;
    Icon: SvgIconComponent;
}

export const useActions = (row: any): Action[] => {
    const navigate = useNavigate();

    return useMemo(() => {
        const status = row?.status;

        const viewInvoice = {
            title: 'View invoice',
            onClick() {
                navigate(`${row?.type}/${row?.id}/view`);
            },
            Icon: RemoveRedEye,
        };

        const activate = {
            title: 'Activate',
            onClick() {
                navigate(`${row?.type}/${row?.id}/confirm`);
            },
            Icon: LibraryAddCheck,
        };

        const archive = {
            title: 'Delete',
            onClick() {
                navigate(`${row?.type}/${row?.id}/delete`);
            },
            Icon: Delete,
        };

        const seePaymentSchedules = {
            title: 'See payment schedules',
            onClick() {},
            Icon: Payments,
        };

        const exportReport = {
            title: 'Export report',
            onClick() {},
            Icon: ImportExport,
        };

        const res: Action[] = [viewInvoice];

        if (status === InvoiceStatus.Created) {
            res.push(activate);
            // res.push(archive);
        }

        // if (status === DealStatus.Available) {
        //     res.push(activate);
        // } else if (status === DealStatus.InProgress) {
        //     res.push(seePayemntSchedules);
        //     res.push(exportReport);
        // } else if (status === DealStatus.Overdue) {
        //     res.push(seePayemntSchedules);
        //     res.push(exportReport);
        // } else if (status === DealStatus.Complete) {
        //     res.push(exportReport);
        // }

        return res;
    }, [row]);
};

export interface ActionNew {
    type: ActionType;
    label: string;
    onClick(): void;
    icon: SvgIconComponent;
}

export interface ActionCallbacks {
    onArchive?: (invoiceId: string) => void;
}

export const useActionsNew = (
    row: InvoiceTableRow | undefined,
    callbacks?: ActionCallbacks
): ActionNew[] => {
    const navigate = useNavigate();

    return useMemo(() => {
        const res: ActionNew[] = [];

        const schedule = {
            type: ActionType.Schedule,
            label: 'Schedule FundNow',
            onClick() {
                navigate(`${row?.type}/${row?.id}/confirm`);
            },
            icon: Schedule,
        };

        const edit = {
            type: ActionType.Edit,
            label: 'Edit',
            onClick() {
                navigate(`${row?.type}/${row?.id}/confirm`);
            },
            icon: Edit,
        };

        const viewInvoice = {
            type: ActionType.View,
            label: 'View invoice',
            onClick() {
                navigate(`${row?.type}/${row?.id}/view`);
            },
            icon: RemoveRedEye,
        };

        const archive = {
            type: ActionType.Archive,
            label: 'Delete',
            onClick() {
                if (callbacks?.onArchive && row?.id) {
                    callbacks.onArchive(row.id);
                }
            },
            icon: Delete,
        };

        switch (row?.status) {
            case InvoiceTableRowStatus.Ready:
                res.push(schedule);
                res.push(edit);
                res.push(viewInvoice);
                // res.push(archive); // NOTE: Archive route is not available for FundNow
                break;
            default:
                res.push(viewInvoice);
                break;
        }

        return res;
    }, [row]);
};
